<div mat-dialog class="create-an-account">
    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
    <mat-dialog-content style="min-height: 570px;">
        <a class="header float-end" (click)="dialogRef.close()">X</a>
        <h6 class="header" style="margin-top: 10px;">Create an Account</h6>
        <div class="Vert-20"></div>
        <p>Create an HomeDashboard account to customize your rates and get personalized loans opportunities.
        </p>
        <div class="Vert-10"></div>
       
        <form [formGroup]="createAccountForm">
            <div class="row">
                <mat-form-field class="col-12" appearance="outline" floatLabel="always" [hideRequiredMarker]="true">
                    <mat-label>First</mat-label>
                    <input type="text" matInput formControlName="firstName">
                    <mat-error *ngIf="createAccountForm.controls.firstName.errors?.required">
                        First Name is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-12" appearance="outline" floatLabel="always" [hideRequiredMarker]="true">
                    <mat-label>Last</mat-label>
                    <input type="text" matInput formControlName="lastName">
                    <mat-error *ngIf="createAccountForm.controls.lastName.errors?.required">
                        Last Name is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-12" appearance="outline" floatLabel="always" [hideRequiredMarker]="true">
                    <mat-label>Email</mat-label>
                    <input type="text" matInput formControlName="email">
                    <mat-error *ngIf="createAccountForm.controls.email.errors?.required">
                        Email is required.
                    </mat-error>
                    <mat-error *ngIf="!createAccountForm.controls.email.errors?.required">
                        Please enter a valid email.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-12" appearance="outline" floatLabel="always" [hideRequiredMarker]="true">
                    <mat-label>Phone (Cell)</mat-label>
                    <input type="text" matInput formControlName="phone">
                    <mat-error *ngIf="createAccountForm.controls.phone.errors?.required">
                        Phone is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <button class="btn btn-primary" mat-button (click)="onSignUp()" [disabled]="!createAccountForm.valid">Sign Up</button>
            <div class="Vert-10"></div>
            <p>By signing up for HomeDashboard you agree to Realfinity’s <a href="https://realfinity.io/legal/privacy-policy/">Privacy Policy</a> and <a href="https://realfinity.io/legal/ ">Terms of Use.</a></p>
            </form>
        </mat-dialog-content>
</div>